import { connect } from 'react-redux';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import {
  secondaryMarketProductCodeSearchClear,
  secondaryMarketProductCodeTypeChanged,
} from 'state/secondaryMarket/productSearch';
import type { ProductCodeType } from 'state/secondaryMarket/productSearch/productSearch.model';
import { SecondaryMarketProductCodeSearchRequestedThunk } from 'state/secondaryMarket/productSearch/productSearch.thunks';
import { fromSecondaryMarket, getIsUserInternal } from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

type OwnProps = {
  className?: string;
};

type StateProps = {
  isInternalUser: boolean;
  codeType: ProductCodeType;
  isLoading: boolean;
  hasSearchFailed: boolean;
  badCodes: readonly string[];
};

export type CodeSearchProps = OwnProps & StateProps & DispatchProps;

const mapStateToProps = (state: AppState): StateProps => {
  return {
    isInternalUser: getIsUserInternal(state),
    codeType: fromSecondaryMarket.productSearch.getSecondaryMarketProductSearchCodeType(state),
    isLoading: fromSecondaryMarket.productSearch.isSecondaryMarketProductSearchLoading(state),
    hasSearchFailed: fromSecondaryMarket.productSearch.hasSecondaryMarketProductSearchTechnicalErrors(state),
    badCodes: fromSecondaryMarket.productSearch.getSecondaryMarketProductMissingCodes(state),
  };
};

type DispatchProps = {
  onCodeTypeChanged: (value: ProductCodeType) => void;
  onSearchCodes: (type: ProductCodeType, codes: string[]) => void;
  onClearSearchedCodes: (badCodes: readonly string[]) => void;
};

const mapDispatchToProps = (dispatch: ThunkDispatch, _: OwnProps): DispatchProps => ({
  onCodeTypeChanged: value => {
    dispatch(secondaryMarketProductCodeTypeChanged(value));
  },
  onSearchCodes: (type, codes) => {
    dispatch(SecondaryMarketProductCodeSearchRequestedThunk(type, codes));
  },
  onClearSearchedCodes: codes => {
    logAnalytics.trackEvent('Secondary market', 'Clear search result');
    dispatch(secondaryMarketProductCodeSearchClear(codes));
  },
});

export const connectCodeSearch = connect(mapStateToProps, mapDispatchToProps);
